module.exports = __webpack_public_path__ + "img/subject.a206c269.svg";